import SeleccionBobinasPvsPage from "../../pages/legacy/seleccionBobinas/SeleccionBobinasPvsPage";

const route = {
  key: "seleccionBobinasPvs",
  path: "/legacy/seleccion-bobinas-pvs",
  component: SeleccionBobinasPvsPage,
  private: true,
  layout: "main",
  icon: "faLayerGroup",
  group: "sales",
  order: 21.5,
  permission: "legacy.salesorder.read"
};

export default route;
